import { useEffect, useState } from "react";

import { Banner } from "../util/banners";

export default function BannerView({ banner }: { banner: Banner }) {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const val = localStorage.getItem(`bannerview--${banner.key}`);
    setShowBanner(val === "show" || val === null);
  }, []);

  return (
    <div
      className={`${
        showBanner ? "py-3" : "py-1"
      } cursor-pointer z-40 banner transition-colors duration-200 px-4 sticky top-0 lg:relative`}
      onClick={() => {
        localStorage.setItem(
          `bannerview--${banner.key}`,
          showBanner ? "hide" : "show"
        );
        setShowBanner(!showBanner);
      }}
    >
      {showBanner && (
        <div className="w-full relative flex flex-row items-center justify-center">
          {banner.description}
        </div>
      )}
    </div>
  );
}
